import { Currency } from "@bentolabs/kit/entities";
import { Tokens } from "@bentolabs/statistics-worker";
import { useQuery } from "@tanstack/react-query";
import invariant from "tiny-invariant";
import { useChainId, usePublicClient } from "wagmi";

import { tokensMeta } from "shared/config/tokens";

export const useTokenListQuery = () => {
  const pc = usePublicClient();
  const chainId = useChainId();

  return useQuery({
    queryKey: ["statistics", "tokens"],
    queryFn: async () => {
      invariant(pc, "useTokenListQuery. pc is undefined");

      const response = await fetch("/statistics/tokens");
      const tokens: Tokens = await response.json();

      const result: Currency[] = tokens.depositTokens.map((t) => {
        const meta = tokensMeta[t.symbol];
        return { decimals: 6, ...t, ...meta, chainId };
      });

      const withdrawalTokens: Currency[] = tokens.withdrawTokens.map((t) => {
        const meta = tokensMeta[t.symbol];
        return { decimals: 6, ...t, ...meta, chainId };
      });

      return { withdrawalTokens, depositTokens: result };
    },
  });
};
